export default __webpack_public_path__ + "static/slide-2-2f120d22ab29f61a957df678f5512ae7.jpg";